import './single-category-news.scss'

class SingleCategoryNews {
  state = {
    category: null,
    page: 1,
  }
  spinner
  content
  categories = []

  constructor() {
    this.spinner = document.querySelector('[data-scn-spinner]');
    this.content = document.querySelector('[data-scn-content]');
    this.categories = Array.from(document.querySelectorAll('[data-category-id]'));

    if (this.categories.length > 0) {
      this.state = {
        ...this.state,
        category: Number(this.categories[0].dataset.categoryId),
      }

      this.events()
    }
  }

  events() {
    document.addEventListener('click', (e) => {
      const page = e.target.closest("[data-page-id]");
      if(page) {
        this.state = {
          ...this.state,
          page: page.dataset.pageId,
        }

        this.update()
      }
    })

    this.categories.map(category => category.addEventListener('click', () => {
      this.state = {
        category: category.dataset.categoryId,
        page: 1,
      }

      this.categories.map(category => category.classList.remove('active'));
      category.classList.add('active');

      this.update()
    }))
  }

  update() {
    if (!this.state.category || !this.state.page) {
      return
    }

    this.spinner.classList.add('active');

    fetch(`/wp-json/customer-collective/v1/latest-posts/${this.state.category}/${this.state.page}`)
        .then(response => {
          if (response.ok ) {
            return response.json()
          }
        })
        .then(response => this.content.innerHTML = response.data)
        .catch(() => console.log('error'))
        .finally(() => this.spinner.classList.remove('active'));
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  new SingleCategoryNews();
})
